export default __webpack_public_path__ + "static/media/pdf.b564ba67.png";